import {SearchFilterConfig, ResourceConfig, SoftDeleteResource} from "@hidat/huijs-resource";
import {
  AnyHash,
  FieldConfig,
  FieldDataTypes,
  nNumber,
  nString,
  uBoolean,
  uNumber,
  uString,
  Uuid
} from "@hidat/huijs-common";
import {RblFieldConfigs, RblTenantResourceInterface} from "../rbl-resource.interface";
import {ZonedDateTime} from "@js-joda/core";

export const LibraryTitleFields = {
  id: RblFieldConfigs.id,
  uid: RblFieldConfigs.uid,
  library: RblFieldConfigs.library,

  name: RblFieldConfigs.name.setRequired(true),
  nameExtended: new FieldConfig('nameExtended'),
  artistName: new FieldConfig('artistName'),
  collectionName: new FieldConfig('collectionName'),
  albumArtistName: new FieldConfig('albumArtistName'),
  releaseYear: new FieldConfig('releaseYear'),
  labelName: new FieldConfig('labelName'),
  publisherName: new FieldConfig('publisherName'),
  mastersAdmin: new FieldConfig('mastersAdmin'),
  performancesAdmin: new FieldConfig('performancesAdmin'),
  mechanicalsAdmin: new FieldConfig('mechanicalsAdmin'),

  nameKeyword: new FieldConfig('nameKeyword'),
  artistKeyword: new FieldConfig('artistKeyword'),

  trackNum: new FieldConfig('trackNum', FieldDataTypes.INTEGER),
  totalTracks: new FieldConfig('totalTracks', FieldDataTypes.INTEGER),
  duration: new FieldConfig('duration', FieldDataTypes.NUMBER),

  contentExtended: new FieldConfig('contentExtended', FieldDataTypes.IGNORED).setEditable(false),
  metaExtended: new FieldConfig('metaExtended', FieldDataTypes.IGNORED).setEditable(false),
  contentDate1: new FieldConfig('contentDate1', FieldDataTypes.DATETIME),
  contentDate2: new FieldConfig('contentDate2', FieldDataTypes.DATETIME),
  contentRating: new FieldConfig('contentRating', FieldDataTypes.INTEGER),
  licensingStatus: new FieldConfig('licensingStatus', FieldDataTypes.INTEGER),

  shortCode: new FieldConfig('shortCode').setRequired(true),
  contentKlass: new FieldConfig('contentKlass').setRequired(true),

  isCollection: new FieldConfig('isCollection', FieldDataTypes.BOOLEAN),
  collectionTitleId: new FieldConfig('collectionTitleId', FieldDataTypes.INTEGER).setEditable(false),
}

export const LibraryTitleConfig = new ResourceConfig('LibraryTitle', 'library_titles', true, true)
  .addFields(Object.values(LibraryTitleFields))
  .setSorts({
    name: "name",
    artistname: {
      dbName: 'artistName',
      secondarySort: {
        dbName: 'name'
      }
    },
    collectionname: {
      dbName: 'collectionName',
      secondarySort: {
        dbName: 'name'
      }
    }
  })
  .setDefaultSort('name')

export const RecordingConfig = new ResourceConfig('RECORDING', 'recordings', true, true);


export interface LibraryTitleInterface extends RblTenantResourceInterface, SoftDeleteResource {

  name: uString;
  nameExtended: nString;
  artistName: nString;
  collectionName: nString;
  albumArtistName: nString;
  releaseYear: nString;
  labelName: nString;
  publisherName: nString;
  trackNum: nNumber;
  totalTracks: nNumber;
  duration: nNumber;

  contentExtended: AnyHash | undefined;
  metaExtended: AnyHash | undefined;
  contentDate1: ZonedDateTime | undefined;
  contentDate2: ZonedDateTime | undefined;

  contentRating: uNumber;
  licensingStatus: uNumber;

  shortCode: uString;
  contentKlass: uString;
  isCollection: uBoolean;

  uid: Uuid | undefined;
  libraryId: uNumber;
  collectionTitleId: uNumber;

  titleId: nNumber;
  nameKeyword: nString;
  artistKeyword: nString;
  mastersAdmin: nString;
  performancesAdmin: nString;
  mechanicalsAdmin: nString;
}

export const LibraryTitleFilterConfig = new SearchFilterConfig(LibraryTitleConfig, {only: ['name', 'collectionName', 'artistName']}
);
